"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalFetch = void 0;
var sequential_fetch_queue_1 = require("./sequential-fetch-queue");
var fetch = require("cross-fetch");
var fetchTimeout = 20000;
var queueTimeout = 120000;
function internalFetch(url, options, callback) {
    var request = new fetch.Request(url, options);
    return fetchQueue.add(request, callback);
}
exports.internalFetch = internalFetch;
/**
 * NOTE: The cross-fetch type declarations suggest that either of these import statements should work, but they don't:
 * import { fetch } from 'cross-fetch';
 * import fetch from 'cross-fetch';
 */
var fetchQueue = new sequential_fetch_queue_1.SequentialFetchQueue(fetch, fetchTimeout, queueTimeout);
//# sourceMappingURL=fetch.js.map